<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  created() {
    window.document.title = '健康证信息服务';
  }
}
</script>

<style lang="less">
html, body, #app {
  width: 100%;
  height: 100%;
  min-height: 100%;
  background-color: #ededed;
}

#app {
  height: auto;
}
</style>
